//Main.JS
function prixvillegiature_refresh_size_queries() {
    var classes = [];
    var scrollbarwidth = prixvillegiature_getScrollbarWidth();
    window_width = $(window).width() + scrollbarwidth;
    window_height = $(window).height();
    is_phone = (window_width < 768);
    is_mobile = (window_width < 992);
    is_small_desktop = (window_width <= 1024);
    is_tablet_portrait = (window_width >= 768 && window_width < 992);
    is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
    is_tablet = is_tablet_portrait || is_tablet_landscape;
    is_desktop = (window_width >= 992);
    is_desktop_large = (window_width >= 1200);

    if (is_phone) {
        classes.push('mq_phone');
    }
    if (is_mobile) {
        classes.push('mq_mobile');
    }
    if (is_tablet_portrait) {
        classes.push('mq_tablet_portrait');
    }
    if (is_tablet_landscape) {
        classes.push('mq_tablet_landscape');
    }
    if (is_tablet) {
        classes.push('mq_tablet');
    }
    if (is_desktop) {
        classes.push('mq_desktop');
    }
    if (is_desktop_large) {
        classes.push('mq_desktop_large');
    }


    $('html').removeClass('mq_phone');
    $('html').removeClass('mq_mobile');
    $('html').removeClass('mq_tablet_portrait');
    $('html').removeClass('mq_tablet_landscape');
    $('html').removeClass('mq_tablet');
    $('html').removeClass('mq_desktop');

    $('html').addClass(classes.join(' '));
}

function prixvillegiature_getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";
    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    // remove divs
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
}

function fixedHeader() {
    if (is_desktop) {
        $(document).scroll(function () {
            var scroll = $(this).scrollTop();
            var header = $('header');

            if (scroll > 300) {
                header.addClass('fixed');
            } else {
                header.removeClass('fixed');
            }
        });
    }
}

function hamburger() {
    $("#hamburger").on('click', function () {
        $(this).toggleClass("is-active");
        $('.header-menu').toggleClass('open');
    });

}

function slideshow() {

    if ($('#slideshow').length) {
        // SPLIDE.JS //
        //Initialize SLIDESHOW Splide.JS
        var slideshow = new Splide('#slideshow', {
            type: 'loop',
            arrows: true,
            pauseOnHover: false, // must be false
            pauseOnFocus: false, // must be false
            resetProgress: false,
            lazyLoad: 'nearby',
            autoplay: true,
            interval: 3500,
            speed: 1000,
            dragMinThreshold: 100,
            wheelMinThreshold: 50,
            pagination: false,
        }).mount();

        //initialize current slide number
        let currentSlide = $('#slideshow .splide__slide-counter .currentSlide');
        currentSlide.text(slideshow.index + 1);
        //initialize total slides number
        const totalSlide = $('#slideshow .splide__slide-counter .totalSlide');
        totalSlide.text("/" + slideshow.length);

        slideshow.on('move', function () {
            //update current slide number
            let currentSlide = $('#slideshow .splide__slide-counter .currentSlide');
            currentSlide.text(slideshow.index + 1);
        });
    }
}

function judges() {
    if ($('.hp__judges').length) {
        // SPLIDE.JS //
        //Initialize JUDGES Splide.JS
        var judges = new Splide('#judges_splide', {
            type: 'slide',
            arrows: true,
            resetProgress: false,
            perPage: 5,
            trimSpace: 'move',
            gap: '20px',
            live: false,
            lazy: 'nearby',
            pagination: false,
            breakpoints: {
                992: {
                    perPage: 3,
                    gap: '10px',
                },
                768: {
                    perPage: 1,
                },
            }
        }).mount();

        // Get pagination current slides
        const currentSlides = $('.hp__judges .splide__list .splide__slide.is-visible');
        const numCurrentSlides = currentSlides.length;
        const resultCurrentSlides = 1;

        // Get pagination total slides
        const totalSlides = $('.hp__judges .splide__list .splide__slide:not(.splide__slide--clone)');
        const numTotalSlides = totalSlides.length;
        const resultTotalSlide = Math.ceil(numTotalSlides / numCurrentSlides);

        //initialize current slide number
        const currentSlide = $('.hp__judges .splide__slide-counter .currentSlide');
        currentSlide.text(resultCurrentSlides);

        //initialize total slides number
        const totalSlide = $('.hp__judges .splide__slide-counter .totalSlide');
        totalSlide.text("/" + resultTotalSlide);

        judges.on('move', function (prevIndex) {
            //update current slide number
            let currentSlide = $('.hp__judges .splide__slide-counter .currentSlide');
            currentSlide.text(Math.ceil(prevIndex / numCurrentSlides) + 1);
        });
    }
}

function prizes() {
    const prizesSplide = $('.prizes_splide');
    if (prizesSplide.length) {
        // SPLIDE.JS //
        //Initialize PRIZES Splide.JS

        let i = 1;
        prizesSplide.each(function () {
            let prizesSplideItems = $(this).find('li').length;
                let prizes = new Splide('#prizes_splide_' + i, {
                    type: 'loop',
                    arrows: true,
                    resetProgress: false,
                    perPage: 3,
                    perMove: 1,
                    focus: 'center',
                    gap: 80,
                    padding: 60,
                    live: false,
                    lazy: 'nearby',
                    pagination: false,
                    breakpoints: {
                        1301: {
                            gap: 40,
                            padding: 30,
                        },
                        992: {
                            gap: 30,
                            padding: 10,
                            perPage: 2,
                        },
                        768: {
                            gap: 40,
                            padding: 30,
                            perPage: 1,
                        },
                    }
                }).mount();

                //initialize current slide number
                let currentSlide = $('#prizes_splide_' + i + ' ' + '.splide__slide-counter .currentSlide');
                currentSlide.text(prizes.index + 1);
                //initialize total slides number
                const totalSlide = $('#prizes_splide_' + i + ' ' + '.splide__slide-counter .totalSlide');
                totalSlide.text("/" + prizes.length);

                for (let i = 1; i < prizesSplide.length + 1; i++) {
                    prizes.on('moved', function () {
                        //update current slide number
                        let currentSlide = $('#prizes_splide_' + i + ' .splide__slide-counter .currentSlide');
                        currentSlide.text(prizes.index + 1);
                    });
                }
                i++;
            if (prizesSplideItems < 2) {
                prizes.destroy(true);
                $(this).addClass('not-carousel');
            }
        });
    }
}

function categoryPrizes() {
    const sidebar = $('#awards__sidebar');
    const chooseCategory = $('#awards__icon');
    const closeBtn = $('#close_sidebar');
    const header = $('header');

    if (is_desktop) {
        $(document).on('scroll', function () {
            var scroll = $(this).scrollTop();
            var header = $('header');

            if (header.hasClass('fixed')) {
                chooseCategory.css({
                    'top': '119px'
                });
            } else {
                chooseCategory.css({
                    'top': '195px'
                });
            }

            if (header.hasClass('fixed')) {
                sidebar.addClass('fixing');
                chooseCategory.addClass('fixing');
            } else {
                sidebar.removeClass('fixing');
                chooseCategory.removeClass('fixing');
            }
        });

        if (!(header.hasClass('fixed'))) {
            chooseCategory.css({
                'top': '195px !important'
            });
        }
    }

    if (is_mobile) {
        chooseCategory.addClass('affix');
    } else {
        chooseCategory.removeClass('affix');
    }

    chooseCategory.on('click', function () {
        sidebar.toggleClass('open');
        chooseCategory.css({
            'top': '195px !important'
        });
    });

    closeBtn.on('click', function () {
        sidebar.toggleClass('open');
        if (sidebar.hasClass('open')) {
            chooseCategory.addClass('fixing');
        } else {
            chooseCategory.removeClass('fixing');
        }
    });

    $(document).on('mouseup', function (e) {
        // if the target of the click isn't the container nor a descendant of the container
        if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0) {
            sidebar.removeClass('open');
        }
    });


    $(".categoryPrize").on('click', function (event) {
        event.preventDefault();
        $(".categoryPrize").removeClass('selected');
        $(this).addClass('selected');
        var currentScrollID = $(this).attr('data-scroll-id');

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".single_prize[data-scroll-id = " + currentScrollID + "]").offset().top - 50
        }, 500);

        sidebar.toggleClass('open');
    });
}

function winners() {
    if ($('.hp__awards').length) {
        // SPLIDE.JS //
        //Initialize HOME AWARDS Splide.JS
        var winners = new Splide('#hp_awards__splide', {
            type: 'loop',
            arrows: true,
            resetProgress: false,
            perPage: 4,
            trimSpace: 'move',
            gap: '20px',
            padding: 10,
            live: false,
            lazy: 'nearby',
            pagination: false,
            breakpoints: {
                1301: {
                    perPage: 3,
                },
                992: {
                    perPage: 2,
                    gap: '10px',
                    padding: 5,
                },
                768: {
                    perPage: 1,
                },
            }
        }).mount();

        // Get pagination current slides
        const currentSlides = $('#hp_awards__splide .splide__list .splide__slide.is-visible');
        const numCurrentSlides = currentSlides.length;
        const resultCurrentSlides = 1;

        // Get pagination total slides
        const totalSlides = $('#hp_awards__splide .splide__list .splide__slide:not(.splide__slide--clone)');
        const numTotalSlides = totalSlides.length;
        console.log(numTotalSlides);
        const resultTotalSlide = Math.ceil(numTotalSlides / numCurrentSlides);

        //initialize current slide number
        const currentSlide = $('#hp_awards__splide .splide__slide-counter .currentSlide');
        currentSlide.text(resultCurrentSlides);

        //initialize total slides number
        const totalSlide = $('#hp_awards__splide .splide__slide-counter .totalSlide');
        totalSlide.text("/" + resultTotalSlide);

        winners.on('move', function (prevIndex) {
            //update current slide number
            let currentSlide = $('#hp_awards__splide .splide__slide-counter .currentSlide');
            currentSlide.text(Math.ceil(prevIndex / numCurrentSlides) + 1);
        });
    }
}

function language_switch() {
    $('.lang_selector .language').on('click', function () {
        $('.lang_selector .language_submenu').toggleClass('open_language');
    });
}

function scrollTop() {
    // declare variable
    var scrollTop = $(".scrollTop");

    $(window).on('scroll', function () {
        // declare variable
        var topPos = $(this).scrollTop();

        // if user scrolls down - show scroll to top button
        if (topPos > 100) {
            $(scrollTop).css("opacity", "1");

        } else {
            $(scrollTop).css("opacity", "0");
        }

    });

    //Click event to scroll to top
    $(scrollTop).on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 100);
        return false;

    });
}

function photogallerySide() {
    var wrap = $('.elements_to_filter .side_wrap');
    if (wrap.length > 0 && is_desktop) {
        var content = wrap.find('.side_content'),
            contentH = content.outerHeight(),
            wrapW = wrap.width(),
            height = wrapW;
        if (contentH < wrapW) {
            height = wrapW;
        } else {
            height = wrapW * 2;
        }
        wrap.css({
            height: height - 1
        });
        filterBtns();
    }
}

function filterSelect() {
    var $container = $('.grid .elements_to_filter'),
        select = $('.filters_select select'),
        filters = {};

    if ($container.length > 0 && select.length > 0) {
        $container.isotope({
            itemSelector: '.thumb_wrap',
            percentPosition: true,
            masonry: {
                columnWidth: '.grid_sizer'
            }
        });

        select.change(function () {
            var $this = $(this);
            var group = $this.attr('data-filter-group');

            filters[group] = $this.find(':selected').attr('data-filter-value');
            var isoFilters = [];
            for (var prop in filters) {
                isoFilters.push(filters[prop])
            }
            var selector = isoFilters.join(''),
                newRel = selector.replace('.', '');

            $container.find(selector).find('.thumb').attr("data-fancybox", newRel);

            $container.isotope({filter: selector});
            return false;
        });


    }
}

function filterBtns() {
    var wrap = $('.grid .elements_to_filter'),
        btns = $('.filters');

    if (wrap.length > 0 && btns.length > 0) {
        var $grid = wrap.isotope({
            itemSelector: '.thumb_wrap',
            columnWidth: '.grid_sizer',
            stamp: '.side_wrap'
        });

        btns.find('li a').click(function () {
            var filterValue = $(this).attr('data-filter-value'),
                newRel = filterValue.replace('.', '');
            btns.find('li').removeClass('active');
            $(this).parent().addClass('active');
            $grid.find(filterValue).find('.thumb').attr("data-fancybox", newRel);
            $grid.isotope({filter: filterValue});


        });
    }
}

function submenu() {
    var submenuMobile = $('.header-menu ul > li.menu-item-has-children > a');
    submenuMobile.after('<span class="more_li"></span>');

    var button = $(".header-menu ul > li.menu-item-has-children > .more_li"),
        parent = $("li.menu-item-has-children"),
        submenu = $("ul.sub-menu"),
        mClass = "open";

    parent.find(submenu).stop().fadeOut();
    button.on('click', function () {
        if (!$(this).closest(parent).hasClass('open')) {
            parent.removeClass(mClass);
            parent.find(submenu).stop().fadeOut();

            $(this).closest(parent).find(submenu).stop().fadeIn(400,
                function () {
                    $(this).closest(parent).addClass(mClass);
                }
            );
        } else {
            $(this).closest(parent).find(submenu).stop().fadeOut(function () {
                400,
                    $(this).closest(parent).removeClass(mClass);
            });
        }

    });
    parent.find('> a').click(function () {
        var link = $(this);
        if (link.attr('href') == 'javascript:;') {

            if (!link.closest(parent).hasClass('open')) {
                parent.removeClass(mClass);
                parent.find(submenu).stop().fadeOut();

                $(this).closest(parent).find(submenu).stop().fadeIn(400,
                    function () {
                        $(this).closest(parent).addClass(mClass);
                    }
                );
            } else {
                link.closest(parent).find(submenu).stop().fadeOut(function () {
                    400,
                        $(this).closest(parent).removeClass(mClass);
                });
            }
        }
    });
}

function paymentGenerator() {
    // Payment links generator
    if (jQuery('form.payment_link_generator').length > 0) {
        var form = jQuery('form.payment_link_generator');
        var all_result_inputs = jQuery('#link_result_fr,#link_result_en');
        var result_fr = jQuery('#link_result_fr');
        var result_en = jQuery('#link_result_en');
        all_result_inputs.val('');
        all_result_inputs.focus(function () {
            jQuery(this).select();
        });
        form.submit(function (e) {
            e.preventDefault();
            all_result_inputs.val('');
            var baseurl = form.data('action');
            if (baseurl) {
                var data = {
                    action: form.find('input[name=action]').val(),
                    name: form.find('input[name=name]').val(),
                    email: form.find('input[name=email]').val(),
                    lead_id: form.find('input[name=lead_id]').val(),
                    amount_usd: form.find('input[name=amount_usd]').val(),
                    amount_eur: form.find('input[name=amount_eur]').val(),
                    description: form.find('input[name=description]').val()
                };
                jQuery.post(baseurl, data, function (data) {
                    if (data.error) {
                        alert(data.message);
                        all_result_inputs.val('');
                    } else {
                        result_fr.val(data.data.fr);
                        result_en.val(data.data.en);
                    }
                }, 'json');
            }
        });
    }
}

function isotope_filters() {
    if ($('body').hasClass('page-template-template-press')) {
        var itemSelector = '.article_wrap';

        if ($('.categories-list').length === 0) return false;

        var $container = $('#press .list');
        $container.isotope({
            transitionDuration: '0.8s',
            resizable: false,
            layoutMode: 'masonry'
        });

        //Ascending order
        var responsiveIsotope = [
            [480, 4],
            [720, 6]
        ];
        var itemsPerPageDefault = 180;
        var itemsPerPage = defineItemsPerPage();
        var currentNumberPages = 1;
        var currentPage = 1;
        var currentFilter = 'all-items';
        var filterAtribute = 'data-category';
        var pageAtribute = 'data-page';
        var pagerClass = 'main-pagination';
        var initPageNumber = 1;

        function changeFilter(selector) {
            $container.isotope({
                filter: selector
            });
        }

        function goToPage(n) {
            currentPage = n;
            var selector = itemSelector;
            // selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
            selector += (currentFilter != 'all-items') ? '[' + filterAtribute + '*="' + currentFilter + '"]' : '[' + pageAtribute + '="' + currentPage + '"]';
            //selector += '[' + pageAtribute + '="' + currentPage + '"]';
            //selector="filter_8";
            changeFilter(selector);
        }


        function defineItemsPerPage() {
            var pages = itemsPerPageDefault;
            // for (var i = 0; i < responsiveIsotope.length; i++) {
            //     if ($(window).width() <= responsiveIsotope[i][0]) {
            //         pages = responsiveIsotope[i][1];
            //         break;
            //     }
            // }
            return pages;
        }

        function setPagination() {
            var itemsLength = $container.children(itemSelector).length;
            var pages = Math.ceil(itemsLength / itemsPerPage);
            var SettingsPagesOnItems = function () {
                // var itemsLength = $container.children(itemSelector).length;
                // var pages = Math.ceil(itemsLength / itemsPerPage);
                var item = 1;
                var page = 1;
                var selector = itemSelector;

                selector += (currentFilter != 'all-items') ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';
                $container.children(selector).each(function () {
                    if (item > itemsPerPage) {
                        page++;
                        item = 1;
                    }
                    $(this).attr(pageAtribute, page);
                    item++;
                });
                currentNumberPages = page;
            }();

            if (pages > 1) {
                var CreatePagers = function () {
                    var $isotopePager = ($('.' + pagerClass).length == 0) ? $('<div class="' + pagerClass + '"></div>') : $('.' + pagerClass);
                    $isotopePager.html('');
                    for (var i = 0; i < currentNumberPages; i++) {
                        $is_first = (i === 0) ? 'current' : '';
                        var $pager = $('<a href="javascript:void(0);" class="pager page-numbers ' + $is_first + '" ' + pageAtribute + '="' + (i + 1) + '"></a>');
                        $pager.html(i + 1);
                        $pager.click(function () {
                            $('.main-pagination a').removeClass('current');
                            var page = $(this).eq(0).attr(pageAtribute);
                            $(this).addClass('current');
                            goToPage(page);

                            setTimeout(function () {
                                var init_posts = 0;

                                $(window).scrollTop(init_posts, {duration: 0});

                            }, 100);
                        });
                        $pager.appendTo($isotopePager);
                    }
                    $container.after($isotopePager);
                }();
            }
        }

        setPagination();
        goToPage(1);


        // filter items on button click
        // $('.post-categories li').on('click', 'a', function () {
        //     var filterValue = $(this).attr('data-category');
        //
        //     // $container.isotope({
        //     //     filter: filterValue,
        //     // });
        //     //
        //     // $('.post-categories li a').removeClass('active');
        //     // $(this).toggleClass('active');
        //
        // });

        $('.categories-list li').on('click', 'a', function () {

            var filter = $(this).attr(filterAtribute);
            currentFilter = filter;

            $(this).siblings().removeClass('active');

            if (!$(this).hasClass('active')) {
                $('.categories-list li a').removeClass('active');
                $(this).addClass('active');
            }


            setPagination();
            goToPage(1);

        });
    }
}

function isotope_filters_blog() {
    if ($('body').hasClass('blog')) {
        var itemSelector = '.post_list__single';

        if ($('.categories-list').length === 0) return false;

        var $container = $('#post-list .post-list__wrap__inner');
        $container.isotope({
            transitionDuration: '0.8s',
            resizable: false,
            layoutMode: 'masonry'
        });

        //Ascending order
        var responsiveIsotope = [
            [480, 4],
            [720, 6]
        ];
        var itemsPerPageDefault = 180;
        var itemsPerPage = defineItemsPerPage();
        var currentNumberPages = 1;
        var currentPage = 1;
        var currentFilter = 'all-items';
        var filterAtribute = 'data-category';
        var pageAtribute = 'data-page';
        var pagerClass = 'main-pagination';
        var initPageNumber = 1;

        function changeFilter(selector) {
            $container.isotope({
                filter: selector
            });
        }

        function goToPage(n) {
            currentPage = n;
            var selector = itemSelector;
            // selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
            selector += (currentFilter != 'all-items') ? '[' + filterAtribute + '*="' + currentFilter + '"]' : '[' + pageAtribute + '="' + currentPage + '"]';
            //selector += '[' + pageAtribute + '="' + currentPage + '"]';
            //selector="filter_8";
            changeFilter(selector);
        }


        function defineItemsPerPage() {
            var pages = itemsPerPageDefault;
            // for (var i = 0; i < responsiveIsotope.length; i++) {
            //     if ($(window).width() <= responsiveIsotope[i][0]) {
            //         pages = responsiveIsotope[i][1];
            //         break;
            //     }
            // }
            return pages;
        }

        function setPagination() {
            var itemsLength = $container.children(itemSelector).length;
            var pages = Math.ceil(itemsLength / itemsPerPage);
            var SettingsPagesOnItems = function () {
                // var itemsLength = $container.children(itemSelector).length;
                // var pages = Math.ceil(itemsLength / itemsPerPage);
                var item = 1;
                var page = 1;
                var selector = itemSelector;

                selector += (currentFilter != 'all-items') ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';
                $container.children(selector).each(function () {
                    if (item > itemsPerPage) {
                        page++;
                        item = 1;
                    }
                    $(this).attr(pageAtribute, page);
                    item++;
                });
                currentNumberPages = page;
            }();

            if (pages > 1) {
                var CreatePagers = function () {
                    var $isotopePager = ($('.' + pagerClass).length == 0) ? $('<div class="' + pagerClass + '"></div>') : $('.' + pagerClass);
                    $isotopePager.html('');
                    for (var i = 0; i < currentNumberPages; i++) {
                        $is_first = (i === 0) ? 'current' : '';
                        var $pager = $('<a href="javascript:void(0);" class="pager page-numbers ' + $is_first + '" ' + pageAtribute + '="' + (i + 1) + '"></a>');
                        $pager.html(i + 1);
                        $pager.click(function () {
                            $('.main-pagination a').removeClass('current');
                            var page = $(this).eq(0).attr(pageAtribute);
                            $(this).addClass('current');
                            goToPage(page);

                            setTimeout(function () {
                                var init_posts = 0;

                                $(window).scrollTop(init_posts, {duration: 0});

                            }, 100);
                        });
                        $pager.appendTo($isotopePager);
                    }
                    $container.after($isotopePager);
                }();
            }
        }

        setPagination();
        goToPage(1);

        $('.categories-list li').on('click', 'a', function () {

            var filter = $(this).attr(filterAtribute);
            currentFilter = filter;

            $(this).siblings().removeClass('active');

            if (!$(this).hasClass('active')) {
                $('.categories-list li a').removeClass('active');
                $(this).addClass('active');
            }


            setPagination();
            goToPage(1);

        });
    }
}

function readmore() {
    if (is_mobile) {
        var preListText = $('#pre_list');
        var preListTextHeight = preListText.height();
        var userLang = $('body').attr("data-lang");

        if (userLang == 'fr') {
            var stringRead = 'En savoir plus';
        } else {
            var stringRead = 'Read More';
        }

        preListText.css('height', '0px');
        preListText.after('<a href="javascript:;" id="readmore_text" class="genericBtn3 translate_center"><span>' + stringRead + '</span><div class="shadow"></div></a>')
        $(document).on('click', '#readmore_text', function () {
            preListText.toggleClass('showmore');
            var text = $('#readmore_text').text();

            if (userLang == 'fr') {
                $('#readmore_text').text(text === "En savoir plus" ? "Fermer" : "En savoir plus");
            } else {
                $('#readmore_text').text(text === "Read More" ? "Close" : "Read More");
            }
        });
    }
}

function newsletter() {
    //Enable fancy box for newsletter on mainpage
    if ($('#newsletter').length > 0 && getCookie('newsletter') !== "read" && getCookie('subscription') !== "subscripted") {
        $.fancybox.open('#newsletter', {
            height: 2000,
            width: 600,
            autoScale: false,
            autoDimensions: false,
        });
        writeCookie('newsletter', 'read', 7)
    } else {
        $('#newsletter').detach();
    }

    //Write and read cookies for newsletter
    function writeCookie(key, value, days) {
        var date = new Date();
        days = days
        date.setTime(+date + (days * 86400000)); //24 * 60 * 60 * 1000
        window.document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
    };

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    }

    $('#gform_submit_button_2').click(function () {
        writeCookie('subscription', 'subscripted', 365)
    });

    $('#input_2_1').attr('placeholder', $('#input_2_1').attr('value'));
    $('#input_2_1').attr('value', '');

    $('.post_summary .lienimg').resizeCenter();

    $(".post_full > div > a").fancybox({
        helpers: {
            title: {
                type: 'float'
            }
        }
    });

    $(".post_full > p > a").fancybox({
        helpers: {
            title: {
                type: 'float'
            }
        }
    });
}

window.isEmpty = function (obj) {
    // null and undefined are "empty"
    if (obj == null) return true;
    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;
    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
};

$(document).ready(function () {

    // Init LazyLoad
    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 50
    });
    prixvillegiature_refresh_size_queries();
    fixedHeader();
    slideshow();
    judges();
    prizes();
    paymentGenerator();
    categoryPrizes();
    scrollTop();
    hamburger();
    submenu();
    photogallerySide();
    filterSelect();
    language_switch();
    winners();
    isotope_filters();
    isotope_filters_blog();
    readmore();
    //newsletter();
    window.onscroll = function () {
    };
    window.onresize = function (event) {
    };
});